import { z } from 'zod';
import { lt } from '@mews/framework';
import { SchemaFormDefinition } from '@mews-commander/form';
import { AccountingConfigurationWithheldTaxesResult } from '@mews-commander/data-access';
import { createOption } from '@mews-commander/ui';

export const taxWithholdSchema = z.object({
    taxWithholding: z.array(z.string()).default([]),
});

export type TaxWithholdingFormValues = z.infer<typeof taxWithholdSchema>;

export const getTaxWithholdFormDefinition = (data: AccountingConfigurationWithheldTaxesResult) =>
    ({
        fields: {
            taxWithholding: {
                label: lt('TaxWithholdingSelectLabel'),
                field: {
                    type: 'select',
                    options: data.taxes?.map((tax) => createOption({ label: tax.name, value: tax.code })),
                },
            },
        },
    }) satisfies SchemaFormDefinition<typeof taxWithholdSchema>;
